exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-style[data-v-3eb8f6ed]{background:#ececec}i[data-v-3eb8f6ed]{cursor:pointer}.web-version[data-v-3eb8f6ed]{display:block}.responsive-version[data-v-3eb8f6ed]{display:none}@media screen and (max-width:768px){.web-version[data-v-3eb8f6ed]{display:none}.responsive-version[data-v-3eb8f6ed]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3eb8f6ed","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 363
// module chunks = 0